/* eslint-disable max-statements */
import React  from "react";
import styles from "./styles.css";
import Helmet from "react-helmet";
import PropTypes from "prop-types";

import BannerNoCarFoundRevamp from "../../shared/banner-no-car-found-revamp";
import Button from "../../shared/button";

const NoCarFoundRevamp = ({handleViewCars}) => {

    return (
        <React.Fragment>
            <Helmet>
                <meta name="ROBOTS" content="NOINDEX,FOLLOW" />
            </Helmet>
            <div styleName={"styles.wrapper"}>
                <BannerNoCarFoundRevamp />
                <Button text="View all cars" onClick={handleViewCars}/>
            </div>
        </React.Fragment>
    );
};

NoCarFoundRevamp.propTypes = {
    handleViewCars: PropTypes.func
};

export default NoCarFoundRevamp;
